// client/src/coms/settings/sections/StickerSoundSettings.js
// Personal Settings → Stickers & Sounds: the existing sticker and soundboard managers.
import React from 'react';
import { Section } from '../../personalisation/settingsControls';
import StickerManager from '../../components/StickerManager';
import SoundboardManager from '../../components/SoundboardManager';

export default function StickerSoundSettings({ serverKey, serverName }) {
  return (
    <Section id="vx-cat-stickers" title="Stickers & Sounds" description="Your sticker packs and soundboard sounds, packs shared with you, and import/export. Saved to your account.">
      <div id="vx-setting-sticker-packs" data-setting="sticker-packs" className="vx-set-block">
        <h4 className="vx-set-subtitle">Stickers</h4>
        <StickerManager serverKey={serverKey} serverName={serverName} />
      </div>
      <div id="vx-setting-soundboard" data-setting="soundboard" className="vx-set-block">
        <h4 className="vx-set-subtitle">Soundboard</h4>
        <p className="vx-set-hint">Your sound packs, server packs and packs shared with you. Changes here also appear in the soundboard in voice channels.</p>
        <SoundboardManager />
      </div>
    </Section>
  );
}
